import { useScanDeviceApiListQuery } from '@hooks/api/useScanDeviceApiListQuery';
import type { ScanDevice } from 'types/api';

export const useScanDevices = useScanDeviceApiListQuery<ScanDevice>('/devices');
